import { OwcTypography, OwcChip } from "@one/react";
import PropTypes from "prop-types";
import moment from "moment";
import { formatUserDisplay } from "../../../../utils/helpers/text";

// Site-specific "Created by" / "Created on" rows, styled like BookedForUsers /
// DateTimeRange respectively.
const CreatedByCreatedOn = ({ createdBy, createdByEmail, createdAt, usersList, timezone }) => {
  if (!createdBy && !createdAt) {
    return null;
  }

  const creator = (usersList || []).find((item) => item.userId === createdBy || item.email === createdByEmail);
  const createdByLabel = creator ? formatUserDisplay(creator) : createdByEmail || createdBy;
  const createdOnLabel = createdAt ? moment(createdAt).tz(timezone).format("DD-MMM-YYYY, hh:mm A") : "-";

  return (
    <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
      {createdBy && (
        <div>
          <OwcTypography variant="caption" style={{ padding: "3px 0" }}>
            Created by
          </OwcTypography>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            <OwcChip outlined style={{ backgroundColor: "#F5F5F2" }} round icon="user" iconType="outlined" size="small">
              {createdByLabel}
            </OwcChip>
          </div>
        </div>
      )}
      {createdAt && (
        <div>
          <OwcTypography variant="caption" style={{ padding: "3px 0", display: "block" }}>
            Created on
          </OwcTypography>
          <OwcTypography variant="button">{createdOnLabel}</OwcTypography>
        </div>
      )}
    </div>
  );
};

CreatedByCreatedOn.propTypes = {
  createdBy: PropTypes.string,
  createdByEmail: PropTypes.string,
  createdAt: PropTypes.string,
  usersList: PropTypes.arrayOf(
    PropTypes.shape({
      userId: PropTypes.string,
      email: PropTypes.string,
      givenName: PropTypes.string,
      familyName: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  timezone: PropTypes.string,
};

export default CreatedByCreatedOn;
